import { PaginationDto } from '../state/community/models/pagination.dto';

export class Pagination {
    isFinalPage?: boolean;
    size: number;

    private _page?: number;

    constructor(size = 50, page?: number) {
        this.size = size;
        this._page = page;
    }

    get isPaginated(): boolean {
        return this._page !== undefined;
    }

    get page(): number {
        return this._page || 0;
    }

    static fromDto(dto: PaginationDto): Pagination {
        const pagination = new Pagination(dto.size, dto.page);
        pagination.isFinalPage = dto.isFinalPage;
        return pagination;
    }

    initialize(): void {
        this._page = 1;
        this.isFinalPage = false;
    }

    nextPage(): void {
        this._page = (this._page || 1) + 1;
    }

    unset(): void {
        this._page = undefined;
        this.isFinalPage = undefined;
    }

    toDto(): PaginationDto {
        return {
            isFinalPage: this.isFinalPage,
            page: this._page,
            size: this.size,
        } as PaginationDto;
    }
}
